import store from "@/store"
import { useAccountStore } from '@/store/account.store'

export default function authHeader() {
    let data = {}

    const token = store.state.token
    if (token?.xsrf) {
        data['x-xsrf-token'] = token.xsrf
    }

    const account = useAccountStore().getCurrentAccount

    if (account) {
        data['X-Account'] = account.uuid
    }

    return data
}
